import React from 'react';

var COLORS = {
  bgMain: '#0a0f1e',
  bgCard: '#0d1325',
  accent: '#3b82f6',
  textDark: '#e2e8f0',
  textMid: '#94a3b8',
  textMuted: '#64748b',
  border: 'rgba(255,255,255,0.1)',
};

var references = [
  {
    title: 'Reinforcing Bar Properties',
    description: 'Bar sizes #3 through #18: diameter, area, weight, perimeter. Plus area of bars per foot of width at common spacings.',
    code: 'ASTM A615 / A706',
    filename: 'MRVN_Ref_RebarProperties.pdf',
    tags: ['Concrete', 'Reinforcement'],
  },
  {
    title: 'Concrete Clear Cover',
    description: 'Minimum concrete cover requirements for cast-in-place nonprestressed members by exposure condition and member type.',
    code: 'ACI 318-19 Table 20.5.1.3.1',
    filename: 'MRVN_Ref_ConcreteCover.pdf',
    tags: ['Concrete', 'Detailing'],
  },
  {
    title: 'Beam Diagrams and Formulas',
    description: 'Shear, moment, and deflection formulas for simple spans, cantilevers, and fixed-end beams under uniform and concentrated loads.',
    code: 'Common Loading Conditions',
    filename: 'MRVN_Ref_BeamDiagrams.pdf',
    tags: ['Analysis', 'General'],
  },
];

var st = {
  page: { background: COLORS.bgMain, minHeight: '100vh', fontFamily: '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif', color: COLORS.textDark },
  container: { maxWidth: '1100px', margin: '0 auto', padding: '2rem' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '1rem', background: '#080c18', margin: '-2rem -2rem 2rem -2rem', padding: '1.5rem 2rem', borderBottom: '1px solid rgba(30,58,95,0.3)' },
  headerTitle: { fontSize: '1.5rem', fontWeight: 800, color: '#f1f5f9', margin: 0 },
  headerSub: { fontSize: '0.85rem', color: COLORS.textMuted, marginTop: '0.25rem' },
  backBtn: { padding: '0.55rem 1.25rem', background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '6px', color: COLORS.textDark, fontSize: '0.85rem', fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '1.25rem' },
  card: { background: 'linear-gradient(135deg,rgba(30,58,95,0.08) 0%,rgba(15,36,64,0.03) 100%)', border: '1px solid rgba(30,58,95,0.35)', borderRadius: '10px', padding: '1.5rem', display: 'flex', flexDirection: 'column' },
  cardTitle: { fontSize: '1.1rem', fontWeight: 700, color: '#f1f5f9', marginBottom: '0.35rem' },
  cardCode: { fontSize: '0.78rem', fontWeight: 600, color: COLORS.accent, marginBottom: '0.5rem' },
  cardDesc: { fontSize: '0.85rem', color: COLORS.textMuted, lineHeight: 1.55, marginBottom: '1rem', flex: 1 },
  tagRow: { display: 'flex', gap: '0.35rem', marginBottom: '1rem', flexWrap: 'wrap' },
  tag: { fontSize: '0.72rem', fontWeight: 600, color: COLORS.textMid, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.08)', padding: '0.15rem 0.5rem', borderRadius: '100px' },
  dlBtn: { width: '100%', padding: '0.65rem 1rem', background: COLORS.accent, border: 'none', borderRadius: '6px', color: 'white', fontWeight: 700, fontSize: '0.88rem', cursor: 'pointer', fontFamily: 'inherit', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', textDecoration: 'none' },
  pdfIcon: { width: '18px', height: '18px', display: 'inline-block' },
};

function PdfIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style={{ flexShrink: 0 }}>
      <rect x="2" y="1" width="12" height="14" rx="1.5" stroke="white" strokeWidth="1.2" fill="none" />
      <path d="M5 6h6M5 8.5h6M5 11h3" stroke="white" strokeWidth="0.9" strokeLinecap="round" />
    </svg>
  );
}

export default function References({ onBack }) {
  return (
    <div style={st.page}>
      <div style={st.container}>
        <div style={st.header}>
          <div>
            <h1 style={st.headerTitle}>Reference Library</h1>
            <p style={st.headerSub}>Downloadable reference tables and formula sheets for structural engineering practice.</p>
          </div>
          <button style={st.backBtn} onClick={onBack}>{'<-'} Back to Dashboard</button>
        </div>

        <div style={st.grid}>
          {references.map(function(ref, i) {
            return (
              <div key={i} style={st.card}>
                <div style={st.cardCode}>{ref.code}</div>
                <div style={st.cardTitle}>{ref.title}</div>
                <div style={st.cardDesc}>{ref.description}</div>
                <div style={st.tagRow}>
                  {ref.tags.map(function(tag, j) { return <span key={j} style={st.tag}>{tag}</span>; })}
                </div>
                <a href={process.env.PUBLIC_URL + '/' + ref.filename} target="_blank" rel="noopener noreferrer" style={st.dlBtn}>
                  <PdfIcon /> View PDF
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
